/**
 * OrbDocDownloadsCliSLOrbDocDownloadsCliSLPage
 *
 * Page component for OrbDocDownloadsCliSLOrbDocDownloadsCliSLPage
 * Path: /sl/docs/downloads/cli
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocDownloadsCliSLDocScreenView as __OrbDocDownloadsCliSLDocScreenView } from '@/components/traits/OrbDocDownloadsCliSLDocScreenView';
import { OrbDocDownloadsCliSLDocAnalyticsView as __OrbDocDownloadsCliSLDocAnalyticsView } from '@/components/traits/OrbDocDownloadsCliSLDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocDownloadsCliSLOrbDocDownloadsCliSLPageProps {
  // Add any page-level props here
}

export function OrbDocDownloadsCliSLOrbDocDownloadsCliSLPage(_props: OrbDocDownloadsCliSLOrbDocDownloadsCliSLPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Ukaz orb","description":"Vsi ukazi orb: preverjanje, testiranje, prevajanje, streženje in orodja okoli njih.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/downloads/cli"},{"locale":"ar","path":"/ar/docs/downloads/cli"},{"locale":"sl","path":"/sl/docs/downloads/cli"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocDownloadsCliSLDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocDownloadsCliSLDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocDownloadsCliSLOrbDocDownloadsCliSLPage;
